module.exports = __webpack_public_path__ + "static/media/Discussion_Forum_Wordmark.65df188c.png";